export default __webpack_public_path__ + "static/media/16.3cee08f2.jpg";